export const Constants = Object.freeze({
  user: Object.freeze({
    DEFAULT_RISK_TOLERANCE: 50,
  }),

  DEFAULT_INVESTMENT_PROFILE: {
    annual_income_id: 1,
    liquid_net_worth_id: 1,
    total_net_worth_id: 1,
    federal_tax_bracket: 39.6,
  },
  DEFAULT_COUNTRY: 'USA',
  DEFAULT_BIRTH_DATE: '1950-01-01',
  CURRENCY: '$',
  LOCAL_IMAGE_BASE: 'assets/img/',
  S3_BASE: process.env.VUE_APP_BUCKET_URL,
  DEFAULT_TARGET_DATE: '2050-12-01',
});

// compatible with date-fns
export const DATE_FORMAT_DB = 'yyyy-MM-dd';

export const DATE_FORMAT_PRESENTATION = 'MM/dd/yyyy';

export const AUTHENTICATED_SESSION = Object.freeze({
  // 15 min
  TOTAL_SESSION_TIME: 900,
  // 1 min
  MODAL_TIME_SHOWN: 60,
});

export const TRANSACTIONS = Object.freeze({
  CODES: {
    DEPOSIT: ['DEP', 'DJOUR', 'MGFEEIN', 'MGJRLIN', 'REC', 'RETCHECKDEP', 'RWDEP'],
    WITHDRAWAL: ['CJOUR', 'DEL', 'MGJRL', 'RETACH', 'RWDEL', 'RWWITH', 'SUPGPS', 'RETCHECK', 'WITH'],
    INCOME: [
      '5YEAR',
      'CLIEU',
      'DGCAPR',
      'DIV',
      'DVADJ',
      'INT',
      'INTEXP',
      'LGAIN',
      'MGAIN',
      'NDV',
      'PIL',
      'QDV',
      'ROP',
      'ROYALTY',
      'SHTDV',
    ],
    EXPENSE: ['IRAFEE', 'MFEE', 'IRAFEER'],
  },
  NAMES: {
    DEPOSIT: [
      'Deposit',
      'Debit journal entry',
      'Cash Transfer In',
      'Cash Journal - Cash In',
      'REC',
      'Returned Check',
      'Return Check Deposit',
      'RW Deposit (establishing positions)',
    ],
    WITHDRAWAL: [
      'Credit journal entry',
      'DEL',
      'Cash Journal Activity',
      'Returned ACH',
      'RW Transfer of Securities (account closing)',
      'RW Withdrawal (account closing)',
      'Share Update Per GP Statement',
      'Withdrawal',
    ],
    INCOME: [
      '5 Year Gain',
      'Cash In Lieu Transaction',
      'Long Term Cap Gain Adjustment',
      'Dividend',
      'Dividend Adjustment',
      'Interest',
      'Interest Expense',
      'Long Term Cap Gain',
      'Mid Term Cap Gain',
      'Non-qualified Dividend',
      'Payment In Lieu',
      'Qualified Dividend',
      'Return of Principal',
      'Royalty Payments',
      'Short Dividend',
    ],
    EXPENSE: ['IRA Fee Reversal', 'Management Fee'],
  },
  WEBNAMES: {
    DEPOSIT: ['Deposit', 'Deposits'],
    WITHDRAWAL: ['Withdrawal', 'Withdrawals'],
    INCOME: ['Income', 'Deposits'],
    EXPENSE: ['Expenses', 'Advisory Fees'],
  },
  DEFAULTS: {
    LIMIT: 5,
    LIMITS: [5, 10, 20, 30],
  },
});

export const IMG = {
  TOTAL_PORTFOLIO_VALUE: 'assets/img/total-value.svg',
  TOTAL_CASH_VALUE: 'assets/img/total-cash.svg',
  RISK_OVERVIEW: 'assets/img/risk-icon.svg',
  TOTAL_PORTFOLIO_VALUE_CLASSIC: 'uploads/thumbnails/ria/64/portalsettings/ic-portfolio.svg',
  TOTAL_CASH_VALUE_CLASSIC: 'uploads/thumbnails/ria/64/portalsettings/ic-cash.svg',
};

export const TRANSFER_DIRECTION = Object.freeze({
  1: 'Deposit',
  2: 'Withdrawal',
});

export const ptcQuestion =
  'Is this account holder a control person of a publicly traded company? (Director, Officer or 10% Stock Owner)?';

export const faiQuestion =
  'Are you, or anyone authorized to trade in your account, affiliated with, work with or work for a member firm of a Stock Exchange or FINRA?';

export const spfQuestion =
  'Are you or is a member of your immediate family a current or former politically exposed person or public official (This includes U.S. and foreign individuals)?';

export const apexFintechDisclaimer =
  'Principal Advised Services does not accept new accounts for employees of Apex Fintech Solutions.';

export const DEFAULT_TIMEZONE = 'America/New_York';

export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;

export const PHONE_MASK_CHARS_REGEX = /[ ()-]/g;

export const STANDARD_DEVIATION_CUTOFF = 40;

export const INVESTMENT_MODEL_TITLE = Object.freeze({
  GOAL_BASED_PORTFOLIO: 'Time-based',
  RISK_BASED_PORTFOLIO: 'Risk-based',
});

export enum ComplianceStatus {
  Approved = 'COMPLIANCE_APPROVED',
  Rejected = 'COMPLIANCE_REJECTED',
  ClientApproved = 'AWAITING_COMPLIANCE_APPROVAL',
  ClientUnapproved = 'AWAITING_CLIENT_APPROVAL',
}
